import React, { useState } from 'react';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  notification,
  Row,
} from 'antd';

import GetLabel from 'DisplayFramework/components/GetLabel';

import { addAssetUseValue } from 'services/assets';
import { addFinAssetUseValue } from 'services/finassets';
import { useForm } from 'antd/lib/form/Form';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import FormInput from 'components/FormInput';
import { dateToString } from 'utils/utils2';

type AddAssetUseValueModalProps = {
  visible: boolean;
  onClose: () => void;
  assetdetail: any;
  phase:string;
  use: any;
  refetchassetUse?: () => void;
};
const initialValues = {
  usevalue: '' as any,
  usevaluedate: '' as any,
};

const AddAssetUseValueModal = (props: AddAssetUseValueModalProps) => {
  const { visible, onClose, assetdetail, use, refetchassetUse } = props;
  const [form] = useForm();

  const [isLoading, setisLoading] = useState(false);
  const save = async (values: any) => {
    setisLoading(true);
    if (props.phase==='PROPOSAL') {

    await addAssetUseValue({
      request: {
        assetid: assetdetail.assetid,
        attcode: use.attcode,
        creationdate: '',
        flagupdatefv: false,
        flagupdatemv: false,
        newmarketvalue: 0,
        proctaskid: 0,
        useid: use.id,
        useridcreation: Number(localStorage.getItem('userid')) ?? 0,
        usevalue: values.usevalue,
        usevaluedate: dateToString(values.usevaluedate),
        valueid: 0,
      },
    })
      .then((res) => {
        notification.success({ message: res.message });
        setisLoading(false);
        refetchassetUse && refetchassetUse();
        onClose();
      })
      .catch((res) => {
        notification.error({ message: res.message });
        setisLoading(false);
      });
    }else {
    await addFinAssetUseValue({
      request: {
        assetid: assetdetail.assetid,
        attcode: use.attcode,
        creationdate: '',
        flagupdatefv: false,
        flagupdatemv: false,
        newmarketvalue: 0,
        proctaskid: 0,
        useid: use.id,
        useridcreation: Number(localStorage.getItem('userid')) ?? 0,
        usevalue: values.usevalue,
        usevaluedate: dateToString(values.usevaluedate),
        valueid: 0,
      },
    })
      .then((res) => {
        notification.success({ message: res.message });
        setisLoading(false);
        refetchassetUse && refetchassetUse();
        onClose();
      })
      .catch((res) => {
        notification.error({ message: res.message });
        setisLoading(false);
      });

    }
  };

  return (
    (<Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinishFailed={onFinishFailed}
      onFinish={save}
      labelCol={{ span: 24 }}
    >
      <Modal
        open={visible}
        onCancel={onClose}
        destroyOnClose
        width={500}
        title={<GetLabel label="AddAssetUseValue" />}
        footer={
          <Row justify="end" gutter={8}>
            <Col>
              <Button onClick={onClose}>
                <GetLabel label="cancel" />
              </Button>
            </Col>
            <Col>
              <Button
                onClick={() => {
                  form.submit();
                }}
                type="primary"
                loading={isLoading}
              >
                <GetLabel label="save" />
              </Button>
            </Col>
          </Row>
        }
      >
        <Card>
          <Row gutter={32}>
            <FormInput col xl={12} name="usevalue" rules={[{ required: true }]}>
              <InputNumber min={0} />
            </FormInput>

            <FormInput
              col
              xl={12}
              name="usevaluedate"
              rules={[{ required: true }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </FormInput>
          </Row>
        </Card>
      </Modal>
    </Form>)
  );
};

export default AddAssetUseValueModal;
